var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.chord = function(widget, chart, data, metadata) {
    if (!data || data.length === 0) {
        widget.find('.loading-box').hide();
        return;
    }

    //Widget expects a dependency relation per row in 4 columns: {name (string), dependency (string), bruto (int), netto (int)}
    function parseToJson(data) {

        var kendoConfig = metadata.KendoConfig;

        var parentList = [];
        var items = [];
        data.forEach(function (item) {

            //Define values
            var name = item[Object.keys(item)[0]],
                dependencyName = item[Object.keys(item)[1]];

            var bruto = item[Object.keys(item)[2]],
                netto;

            if (kendoConfig.onevalue) {
                netto = item[Object.keys(item)[2]];
            } else {
                netto = item[Object.keys(item)[3]];
            }

            //The record
            var record = {
                "name": name,
                "size": 0, //Record size will be calculated by adding up all dependencies bruto.
                "imports": []
            }

            //It's dependency
            var dependency = {
                "name": name + "." + dependencyName,
                "size": netto, //Dependency size = netto.
                "imports": []
            }

            //if parent record for dependency doesn't exist, create one.
            if (!parentList.includes(record.name)) {
                parentList.push(record.name);
                items.push(record);
            }

            //Add dependency to appropriate parent record.
            items.push(dependency);
            var recordToEdit = items.find(findNodeByName, [record.name]);
            recordToEdit.imports.push(dependency);
            recordToEdit.size = recordToEdit.size + bruto; //Add dependency bruto to record size
        });
        return items;
    }

    function findNodeByName(node) {

        if (node.name === this[0]) {
            return node;
        }
    }

    widget.find('.loading-box').hide();
    widget.find('.chart').append($('<div class="djs-chord">'));

    var outerRadius = MDB.Charts.calculateKendoChartMaxHeight(widget) / 2,
        innerRadius = outerRadius / 10 * 6;

    var fill = d3.scale.category20c();

    var chord = d3.layout.chord()
        .padding(.04)
        .sortSubgroups(d3.descending)
        .sortChords(d3.descending);

    var arc = d3.svg.arc()
        .innerRadius(innerRadius)
        .outerRadius(innerRadius + 20);

    var svg = d3.select(".djs-chord").append("svg")
        .attr("width", outerRadius * 2)
        .attr("height", outerRadius * 2)
        .append("g")
        .attr("transform", "translate(" + (outerRadius + 80) + "," + outerRadius + ")");

    var imports = parseToJson(data);

    var indexByName = d3.map(),
        nameByIndex = d3.map(),
        matrix = [],
        n = 0;

    // Returns the Flare package name for the given class name.
    function name(name) {
        return name; //.substring(0, name.lastIndexOf(".")).substring(6);
    }

    // Compute a unique index for each package name.
    imports.forEach(function (d) {
        if (!indexByName.has(d = name(d.name))) {
            nameByIndex.set(n, d);
            indexByName.set(d, n++);
        }
    });

    // Construct a square matrix based on item size.
    imports.forEach(function (d) {

        var source = indexByName.get(name(d.name)),
            row = matrix[source],
            size = d.size;

        //If row does not exist yet. Create one and fill with 0 values
        if (!row) {
            row = matrix[source] = [];
            for (var i = -1; ++i < n;) {
                row[i] = 0;
            }
        }

        //Change the item index in the row to represent the item size.
        row[indexByName.get(name(d.name))] = size;
        d.imports.forEach(function (d) {
            row[indexByName.get(name(d.name))] = size 
        });
    });
    chord.matrix(matrix);

    var g = svg.selectAll(".group")
        .data(chord.groups)
        .enter().append("g")
        .attr("class", "group");

    g.append("path")
        .style("fill", function (d) {
            return fill(d.index); 
        })
        .style("stroke", function (d) {
            return fill(d.index); 
        })
        .attr("d", arc);

    g.append("text")
        .each(function (d) {
            d.angle = (d.startAngle + d.endAngle) / 2; 
        })
        .attr("dy", ".35em")
        .attr("transform",
            function (d) {
                return "rotate(" +
                (d.angle * 180 / Math.PI - 90) +
                ")" +
                "translate(" +
                (innerRadius + 26) +
                ")" +
                (d.angle > Math.PI ? "rotate(180)" : "");
            })
        .style("text-anchor", function (d) {
            return d.angle > Math.PI ? "end" : null; 
        })
        .text(function (d) {
            return nameByIndex.get(d.index); 
        });

    svg.selectAll(".chord")
        .data(chord.chords)
        .enter().append("path")
        .attr("class", "chord")
        .style("stroke", function (d) {
            return d3.rgb(fill(d.source.index)).darker(); 
        })
        .style("fill", function (d) {
            return fill(d.source.index); 
        })
        .attr("d", d3.svg.chord().radius(innerRadius))
        .attr("padding-left");


    d3.select(self.frameElement).style("height", outerRadius * 2 + "px");
}
